import AService from '@/services/AService'

const ENTITY_NAME = 'roaming-teams';

export default class RoamingTeamService extends AService {

  async create(roamingTeam){
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, roamingTeam)
    return response.data;
  }

  async fetchRoamingTeamsPagingAndSorting(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`, {params})
    return response.data;
  }

  async fetchById(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`);
    return response.data;
  }

  async update(roamingTeam){
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, roamingTeam)
    return response.data;
  }

  async updateStatus(roamingTeam, value) {
    const response = await this.http.patch(`${this.baseUrl}/${ENTITY_NAME}/${roamingTeam.id}/status?enabled=${value}`);
    return response.data;
  }

  async deleteRoamingTeam(roamingTeam) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${roamingTeam.id}`)
    return response.data;
  }
}
